module.exports = {
      id: "comm-automobile-usage",
      viewBox: "0 0 231.941 38.7",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#comm-automobile",
      toString: function () {
        return this.url;
      }
    }